import { render } from "./GoogleSearchResults.vue?vue&type=template&id=a9019588"
import script from "./GoogleSearchResults.vue?vue&type=script&lang=js"
export * from "./GoogleSearchResults.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__